module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "skip-white.9623180f.svg";